import $ from 'jquery';
(window as any).jQuery = $; // Assign to window.jQuery
(window as any).$ = $;      // Assign to window.$
import '../styles/main.scss';
import 'bootstrap';
import '../apps/navbar/main';
import '../utils/bus.ts';
import Rails from 'rails-ujs'
import '../utils/images.d.ts';
import '../utils/window.d.ts';
import '../utils/analytics/analytics';
import {OnBoardingGoal} from "../utils/models/OnBoardingGoal";
import {AuthMethods} from "../apps/on_boarding/store/modules/OnBoardingModule";
import '../utils/splide';

Rails.start();
console.log("Hello from application.js on vite");

// DYNAMIC IMPORTING
// Only import reviews if #new_review is in the viewport and visible
const $addReviewButton = document.getElementById('new_review');
if ($addReviewButton) {
  import('../apps/reviews/main');
}

console.log('Hello World from Hiiker!');

// Attach event listener to the button
const giftButton = document.getElementById('giftCheckoutButton');
if (giftButton) {
  import('../apps/on_boarding/main');
  giftButton.addEventListener('click', function (e) {
    e.preventDefault();
    if (window.user == null) {
      window.onBoardingVue.launchFor(OnBoardingGoal.CreateAccountForPurchase, [AuthMethods.Email])
      return
    } else {
      window.location.href = window.giftCheckoutUrl;
    }
  });
}

